<template>
  <div class="container">
    <Loader v-if="isLoading" />
    <h4
      v-if="tests.length == 0"
      class="text-center"
    >
      {{ $t('noResult') }}
    </h4>
    <div class="row">
      <div
        v-for="(test, index) in tests"
        :key="index"
        class="col col-12 col-sm-6 col-md-4 mb-4"
      >
        <RouterLink
          :to="`/test/${test._id}`"
          class="test-link position-relative d-block"
        >
          <h6 class="text-light rounded m-4 p-2 test-link-img-title">
            {{ test.question }}
          </h6>
          <img
            :src="test.questionImage"
            class="test-img"
            alt="Image"
          >
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader';

import { API } from '@/services/';
import { API_BASE_URL, API_GET_TESTS_BY_LANGUAGE } from '@/helpers/config';
import { mapGetters } from 'vuex';

export default {
  components: {
    Loader,
  },
  data: () => ({
    isLoading: true,
    tests: [],
    apiBaseUrl: API_BASE_URL,
  }),
  computed: {
    ...mapGetters(['domainWithoutDot']),
  },
  created() {
    // get tests by using selected locale (language code)
    const url = API_GET_TESTS_BY_LANGUAGE + this.$i18n.locale;
    API.get(url).then((response) => {
      this.isLoading = false;
      this.tests = response.data.data;
    });

    // set document title
    document.title = this.$t(`${this.domainWithoutDot}.brand`);
  },
};
</script>
